import script from "./SearchPageSearchPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchPagination.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchPagination.vue?vue&type=style&index=0&id=3226e5c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3226e5c9"]])

export default __exports__